//@ts-ignore
window.ServiceWorkerRegistration = window.ServiceWorkerRegistration ?? { prototype: {} };
